import { Container } from './styles/Container.style';

export default function ContactUs() {
	return (
		<>
			<Container>
				<h1>Contact Us </h1>
			</Container>
		</>
	);
}
